<template>
  <form action="" method="post" name="ListSelect" id="ListSelect">
    <div class="os_noticeRes">
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <div class="osResHeader padLS padRS">
        <h1 class="txtC">
          <img :src="topImgPath">
        </h1>
      </div>
      <div class="padTS padBL padLS padRS">
        <div class="clearfix" style="background-color:#f5f5f5;max-width:710px;margin:0px auto;padding:1.5em 0px;">
          <p class="floL txtC" style="width:25%"><img src="./img/personalIcon.png" alt=""></p>
          <p class="floL fntP pcView" style="width:75%;padding-left:4%;text-align:left;line-height:120px;border-left:1px solid #e5e5e5;">개인정보 관련 동의 완료 후 본인의 항공 일정을 확인하실 수 있습니다.</p>
        </div>
        <div
          class="padTL"
          style="max-width:710px;margin:auto;"
          v-for="(question, index) in form.questions"
          :key="index"
        >
          <p class="marBS fntH6 bolder quill-viewer" style="color:#222;">
            <span style="color:#1874cd;">[ 약관 {{ index + 1 }} ]</span>
            <div class="quill-viewer" v-html="question.text"></div>
          </p>

          <div
            class="quill-viewer"
            style="overflow:scroll; width:100%; height:200px; padding:10px;
           background-color:#f9f9f9; border:1px solid #E0E0E0;"
            v-html="form.answers[index] ? form.answers[index].content : ''"
          >
          </div>

          <p class="marTM txtR moTxtL" style="text-indent:1.1em;max-width:800px">
            <label class="disIb fntP agree-label" >
              <input
                type="radio"
                :name="'agree_' + index"
                value="Y"
                v-model="form.answers[index].agree"
              >
              동의
            </label>
            <label class="disIb fntP agree-label" >
              <input
                type="radio"
                :name="'agree_' + index"
                value="N"
                v-model="form.answers[index].agree"
              >
              동의안함
            </label>
          </p>
        </div>

        <p class="marTL txtC">
          <input :disabled="isPreviewMode" type="button" id="submit_button" @click="handleSubmit" value="항공일정 확인" class="fntP bolder" style="background-color:#1874cd;width:8em;height:2.5em;color:#fff;border:0px;">
        </p>

      </div>
    </div>
  </form>

</template>

<script>
import axios from 'axios'

export default {
  name: 'NcaTerms',
  props: {
    survNo: {
      type: [String, Number],
      required: true
    }
  },
  components: {

  },
  data () {
    return {
      isLoading: false,
      aboInfo: {aboNo: '', aboName: ''},
      surv_no: 0,
      form: {
        answer_cnt: 1,
        surv_type: 'agree',
        questions_cnt: '', // 초기값은 '--'에 해당하는 빈 문자열
        questions: [],
        answers: []
      },
      topImgPath: './img/top.gif'
    }
  },
  async mounted () {
    this.surv_no = this.survNo
    if (!this.isPreviewMode) {
      const isLoggedIn = await this.checkLogin()
      if (!isLoggedIn) return
    }
    await this.getSurveyDetail(this.surv_no)
  },
  computed: {
    isPreviewMode () {
      return this.$route.query.preview === 'true'
    }
  },
  methods: {
    checkLogin: async function () {
      this.isLoading = true
      try {
        const response = await axios.get(
          process.env.OCC_ROOT_URL + '/sso/authorizeEvent',
          { withCredentials: true }
        )
        if (response.data.header.status === 'ERROR') {
          window.location.href = `${process.env.AMWAY_ROOT_URL}/login`
          return false
        }
        if (response.data.customerUid && response.data.customerUid !== 'none') {
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
          return true
        }
        return false
      } catch (e) {
        alert('로그인이 필요합니다.')
        window.location.href = `${process.env.AMWAY_ROOT_URL}/login`
        return false
      } finally {
        this.isLoading = false
      }
    },
    async getSurveyDetail (survNo) {
      this.isLoading = true

      try {
        const params = {
          surv_no: survNo,
          mode: 'question',
          user_id: this.aboInfo.aboNo
        }
        const {data} = await axios.get(
          process.env.AWS_GATEWAY_URL_V2 + `/event-admin/nca/survey-detail`,
          { params }
        )
        if (!data) {
          console.log('Invalid response:', data)
          return
        }
        console.log(138, 'getSurveyDetail success:', data)
        if (data.length === 0) {
          alert('항공정보가 올바르지 않습니다.')
          this.$router.push({name: 'pageNotFound'})
        }
        const base = data.filter(v => v.quest_mult_no === 0)[0]
        const items = data.filter(v => v.quest_mult_no !== 0).sort((a, b) => a.quest_mult_no - b.quest_mult_no)
        console.log(134, 'base', base, base.user_exists_yn)
        if (base.user_exists_yn === 'Y') {
          this.$router.push(`/nca/schedule/${base.surv_no}/${base.user_no}`)
        }
        if (base.surv_top_img) {
          this.topImgPath = base.surv_top_img.replace(/^s3:\/\//, 'https://')
        }
        this.form.questions_cnt = base.quest_cnt
        this.form.answers = items.map(e => ({
          content: e.answer_value,
          agree: 'Y'
        }))
        this.form.questions = items.map(e => ({
          text: e.quest_subject
        }))
      } catch (e) {
        console.error('getSurveyList error:', e)
      } finally {
        this.isLoading = false
      }
    },
    async handleSubmit () {
      this.isLoading = true
      try {
        const disagreeIndexes = this.form.answers
          .map((answer, index) => answer.agree !== 'Y' ? index + 1 : null)
          .filter(v => v !== null)

        if (disagreeIndexes.length > 0) {
          alert(`다음 약관에 동의가 필요합니다: ${disagreeIndexes.join(', ')}번`)
          this.isLoading = false
          return
        }

        const data = {
          ...this.form,
          surv_no: this.surv_no,
          mode: 'terms',
          user_id: this.aboInfo.aboNo
        }

        console.log('data:', data)
        const response = await axios.post(
          process.env.AWS_GATEWAY_URL_V2 + `/event-admin/nca/question`,
          data,
          {
            headers: {'Content-Type': 'application/json;charset=UTF-8'}
          }
        )
        console.log('등록 결과:', response)
        // 등록 성공 후 팝업 닫기
        alert('등록 되었습니다.')
        this.$router.push(`/nca/schedule/${this.surv_no}/${response.data.user_no}`)
      } catch (e) {
        console.error('수정 실패:', e)
        alert('등록 중 문제가 발생했습니다.')
      } finally {
        this.isLoading = false
      }
    }
  }

}
</script>

<style scoped>
  @import './css/font_kr.css';
  @import './css/content_res_reset.css';
  @import './css/content_res_all.css';

  .agree-label {
    margin-right: 20px;
    text-indent: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/nca/terms.vue